import { render } from "./AppointmentCard.vue?vue&type=template&id=685e9d1a&scoped=true"
import script from "./AppointmentCard.vue?vue&type=script&lang=js"
export * from "./AppointmentCard.vue?vue&type=script&lang=js"

import "./AppointmentCard.vue?vue&type=style&index=0&id=685e9d1a&scoped=true&lang=css"
import "./AppointmentCard.vue?vue&type=style&index=1&id=685e9d1a&lang=css"

import exportComponent from "/opt/doctorsp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685e9d1a"]])

export default __exports__